import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-po-ledger-sub-total',
  templateUrl: './po-ledger-sub-total.component.html',
  styleUrls: ['./po-ledger-sub-total.component.scss']
})
export class PoLedgerSubTotalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
